import {
  IonBackButton,
  IonBadge,
  IonButton,
  IonButtons,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonNote,
  IonPage,
  IonRow,
  IonText,
  IonTitle,
  IonToolbar,
  useIonRouter,
} from "@ionic/react";
import {
  bookmarkOutline,
  shareOutline,
  homeOutline,
  home,
  phonePortraitOutline,
} from "ionicons/icons";
import { useParams } from "react-router";
import { blogPosts } from "./blogData";
import "./BlogPost.css";
import { truncate } from "../utils/truncate";
import SocialLinks from "./SocialLinks";
import ContactInfo from "./ContactInfo";
import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import Footer from "../views/Slides/Footer";
import { articles } from "./articleData";

const createSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-") // Replace non-alphanumeric with hyphens
    .replace(/^-+|-+$/g, ""); // Remove leading/trailing hyphens
};

const Article = (props) => {
  const params = useParams();
  const id = props.id || params.id;
  const post = articles.find((post) => post.id === id);
  const CONTACT_POST_ID = "contact-us";
  const SOCIAL_POST_ID = "info";

  const isAbout = post?.id === "about";
  const router = useIonRouter();
  useEffect(() => {
    if (isAbout) {
      document.title =
        "About LoonLog | Canada’s Community-Driven Social Media Platform";

      // Meta description
      let metaDescription = document.querySelector("meta[name='description']");

      if (!metaDescription) {
        metaDescription = document.createElement("meta");
        metaDescription.setAttribute("name", "description");
        document.head.appendChild(metaDescription);
      }

      metaDescription.setAttribute(
        "content",
        "Learn about LoonLog, a Canadian-owned social media platform inspired by the loon and built to reflect Canadian values, community, privacy, and identity."
      );

      // Canonical link
      let canonical = document.querySelector("link[rel='canonical']");

      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }

      canonical.setAttribute("href", "https://loonlog.ca/blog/about");

      // Robots meta (safe explicit declaration)
      let robots = document.querySelector("meta[name='robots']");

      if (!robots) {
        robots = document.createElement("meta");
        robots.setAttribute("name", "robots");
        document.head.appendChild(robots);
      }

      robots.setAttribute("content", "index, follow");
    }
  }, [isAbout]);
  if (!post) {
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonTitle>Post Not Found</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
          <p>😔 The blog post you're looking for doesn’t exist.</p>
        </IonContent>
      </IonPage>
    );
  }

  return (
    <>
      <IonPage className="info-blog-post-page">
        <IonHeader>
          <IonToolbar>
            {/* <IonTitle>{truncate(post.title, 17)}</IonTitle> */}
            <IonButtons slot="start">
              <IonBackButton
                defaultHref="/blog"
                mode="ios"
                text=""
                className="transparent-back-button"
              />
            </IonButtons>
            {/* <IonTitle style={{ padding: "10px" }} className="poetsen"> */}
            <div
              style={{
                display: "flex",
                gap: "5px",
                alignItems: "center",
                padding: "7px",
              }}
              className="poetsen"
            >
              <img
                src="/logo4.png"
                alt="LoonLog Logo"
                style={{ height: "30px" }} // Adjust height and margin as needed
              />
              LoonLog
            </div>
            {/* </IonTitle> */}
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
          <img src={post.image} alt="post header" />

          <IonGrid
            className="ion-padding-start ion-padding-end"
            style={{ paddingTop: "8px" }}
          >
            <IonRow className="ion-align-items-center ion-justify-content-between">
              <IonRow className="ion-align-items-center ion-justify-content-between">
                <img
                  src={post.authorImage}
                  className="blog-author-avatar"
                  alt="post author"
                />
                <IonCardSubtitle
                  className="ion-no-margin ion-no-padding ion-margin-start"
                  style={{ textTransform: "capitalize" }}
                >
                  {post.author}
                </IonCardSubtitle>
                {
                  <h1
                    className="blog-title"
                    style={{
                      marginTop: "0.75rem",
                      marginBottom: "1rem",
                      fontSize: "1.1rem",
                      color: "#262626",
                      lineHeight: "1.3",
                      fontWeight: "500",
                    }}
                  >
                    {post?.title}
                  </h1>
                }
              </IonRow>
              <IonNote style={{ fontSize: "1rem" }}>{post.date}</IonNote>
            </IonRow>

            <IonRow>
              <IonCol size="12">
                {/* {post.id === 8 ? (
                <SocialLinks />
              ) : (
                <IonText
                  color="medium"
                  style={{ whiteSpace: "pre-wrap", fontSize: "14px" }}
                >
                  {post.content}
                </IonText>
              )} */}
                <IonRow>
                  <IonCol size="12">
                    {post.id === SOCIAL_POST_ID ? (
                      <SocialLinks />
                    ) : post.id === CONTACT_POST_ID ? ( // NEW: Render custom ContactInfo component
                      <ContactInfo />
                    ) : (
                      // Default content rendering
                      // <IonText
                      //   color="medium"
                      //   style={{
                      //     whiteSpace: "pre-wrap",
                      //     fontSize: "14px",
                      //     color: "black",
                      //   }}
                      // >
                      //   {post.content}
                      // </IonText>
                      <div
                        style={{
                          whiteSpace: "pre-wrap",
                          fontSize: "14px",
                          color: "black",
                          paddingBottom: "20px",
                          // Inherit the medium color style from IonText if desired
                        }}
                        className="blog-content-container" // Add this class
                        // ⚠️ SECURITY NOTE: Only use this if you trust the source of post.content!
                        // The linkify function should only convert URLs, making it safer,
                        // but be aware of the implications of this prop.
                        dangerouslySetInnerHTML={{
                          __html: post.content,
                        }}
                      />
                    )}
                  </IonCol>
                </IonRow>
              </IonCol>
            </IonRow>
          </IonGrid>
          <Footer />
        </IonContent>

        {post.id !==
          createSlug("Building LoonLog: Canada’s Own Social Media Platform") &&
        post.id !==
          createSlug(
            "Your Story, Our Story: The Heart of Community on LoonLog"
          ) &&
        post.id !== createSlug("Why LoonLog Is More Than Social Media") ? (
          <IonFooter className="view-blog-footer info-post-card">
            <IonRow className="blog-footer ion-align-self-center ion-justify-content-between">
              <div>
                <span onClick={() => router.push("/")}>
                  <IonButton fill="clear" color="primary">
                    {/* 📲 */}
                    <IonIcon
                      icon={phonePortraitOutline}
                      style={{ fontSize: "16px", opacity: 0.7 }}
                    />
                  </IonButton>
                </span>

                <IonButton fill="clear" color="primary">
                  🇨🇦
                </IonButton>
              </div>

              <IonBadge color="primary" className="blog-category">
                {truncate(post.category, 18)}
              </IonBadge>
            </IonRow>
          </IonFooter>
        ) : (
          <IonFooter className="view-blog-footer">
            <IonRow className="blog-footer ion-align-items-center ion-justify-content-between">
              <div
                className="footer-promo"
                aria-label="Launching soon across Canada"
              >
                <div
                  className="footer-promo"
                  aria-label="Launching soon across Canada"
                >
                  🚀 <span className="canada-flag">🇨🇦</span>
                  <span className="promo-text">
                    Launching soon across{" "}
                    <span className="brand-color">Canada</span>
                  </span>
                </div>
              </div>
              {/* Category badge */}
              <IonBadge color="primary" className="blog-category">
                {truncate(post.category, 18)}
              </IonBadge>
            </IonRow>
          </IonFooter>
        )}
      </IonPage>
    </>
  );
};

export default Article;
